/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDetail } from '../../models/content-detail';

export interface GetActualContent$Params {

/**
 * ID obsahu
 */
  id: number;
}

export function getActualContent(http: HttpClient, rootUrl: string, params: GetActualContent$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDetail>> {
  const rb = new RequestBuilder(rootUrl, getActualContent.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDetail>;
    })
  );
}

getActualContent.PATH = '/client/actualContent/{id}';
